import React from 'react'
import { Modal } from '../../../components/Modal/Modal'

export interface CrossClientDeleteModalProps {
  show: boolean
  loading: boolean
  onDelete: () => void | Promise<void>
  onCancel: () => void | Promise<void>
}

export const CrossClientDeleteModal: React.FC<CrossClientDeleteModalProps> = ({ show, loading, onDelete, onCancel }) => {
  return (
    <Modal
      show={show}
      onHide={onCancel}
      header={<h4>Delete this query?</h4>}
      body={<div>This queued query will be removed. This action cannot be undone.</div>}
      centered
      showFooterActions
      bodyClassName='px-4'
      footerPrimaryActionButtonVariant='danger'
      footerPrimaryActionTitle='Delete query'
      footerSecondaryActionTitle='Keep in queue'
      footerPrimaryActionLoading={loading}
      footerSecondaryActionDisabled={loading}
      onFooterPrimaryAction={onDelete}
      onFooterSecondaryAction={onCancel}
    />
  )
}
